/**
 * L2-R8: moved to @miq/platform (services/lookup-category.service.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform'.
 *
 * Moved with its whole cascade (MiqLookupCacheService -> MiqIdbCacheService) so the `streams`
 * lookup dedupe cache, the `inFlight` map and the IndexedDB connection handle are one instance
 * across the host and the reports remote.
 */
export { LookupCategoryService } from '@miq/platform';
export type { ColumnFields, LookUpValue } from '@miq/platform';
